// CommitmentAndTeam.js
import React, { useState } from 'react';

const CommitmentAndTeam = () => {
  const [isFounderOpen, setFounderOpen] = useState(true);

  const toggleFounder = () => setFounderOpen(!isFounderOpen);

  return (
    <div className="mx-12">
      <div className="mb-12">
      <h2 className="text-3xl font-semibold text-center mb-8 text-[#13689b] py-4 rounded-lg">Our Commitment</h2>
        
        <p className="text-black text-md text-justify">
          At WhyMe Solutions, our commitment to excellence is reflected in our dedication to client success. We combine deep industry knowledge with innovative thinking to deliver solutions that are both strategic and actionable. Our client-centric approach ensures that every engagement is tailored to meet specific goals and deliver measurable results.
        </p>
      </div>

      {/* <div className="mb-12">
        <h2 className="text-3xl font-semibold text-center text-black mb-6">Partner with Us</h2>
        <p className="text-black text-lg text-center">
          Discover how WhyMe Solutions can be your trusted partner in achieving transformational outcomes. Connect with us to explore how our multidisciplinary expertise can drive your organization toward a future of unparalleled success and growth.
        </p>
      </div> */}

      <div className="rounded-lg p-6">
      <h2 className="text-3xl font-semibold text-center mb-8 text-[#13689b] rounded-lg">Founders</h2>

        <div className="mb-4">
          <button
            onClick={toggleFounder}
            className="w-full flex justify-between items-center p-4 bg-[#13689b] text-white rounded-lg shadowtransition"
          >
            <span className="text-lg">Founder’s Statement</span>
            <span>{isFounderOpen ? '-' : '+'}</span>
          </button>
          {isFounderOpen && (
            <div className="p-4 bg-white rounded-lg shadow mt-2">
              <p className="text-black text-justify">
                "As the founder of WhyMe Solutions, I am committed to offering my stakeholders holistic solutions in all business areas. Our aim is to provide customized, strategic support that tackles your specific business challenges and fosters long-term growth. By integrating our expertise across these diverse areas, we ensure that all facets of your business work seamlessly together, helping you reach your objectives efficiently. We are devoted to your success and look forward to partnering with you throughout your journey."
                <br /><br />
                ~ Ms. Noureen Muzaffar
              </p>
            </div>
          )}
        </div>

       
      </div>
    </div>
  );
};

export default CommitmentAndTeam;
